import React from 'react';
import PropTypes from 'prop-types';

import { signatureInputStyle } from '../../Settlement/components/Settlement';

const FIELDS = ['Name / Company', 'Phone / Email', 'Signature'];

const PartySignatureLines = ({ parties }) => {
  const rows = [];
  for (let index = 0; index < parties.length; index += 2) {
    rows.push(parties.slice(index, index + 2));
  }

  return (
    <table style={{ width: "100%", fontSize: "14px" }} data-testid="party-signature-lines">
      <colgroup>
        <col style={{ width: "50%" }} />
        <col style={{ width: "50%" }} />
      </colgroup>
      <tbody>
        {rows.map((row, rowIndex) => (
          <tr key={rowIndex}>
            {row.map((party, column) => (
              <td key={column} style={{ verticalAlign: "top", paddingTop: "12px", pageBreakInside: "avoid" }}>
                <div style={column === 0 ? { paddingRight: "10px" } : { paddingLeft: "10px" }}>
                  <p style={{ margin: "0 0 4px 0", fontWeight: "700" }}>{party}</p>
                  {FIELDS.map((field) => (
                    <div key={field}>
                      <label>{field}</label>
                      <input type="text" style={signatureInputStyle} aria-label={`${party} ${field}`} />
                    </div>
                  ))}
                </div>
              </td>
            ))}
            {row.length === 1 ? <td /> : null}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

PartySignatureLines.propTypes = {
  parties: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default PartySignatureLines;
